module.exports = __webpack_public_path__ + "static/img/bill@2x.0cf80de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/seo/bill@2x.png
// module id = ftoJ
// module chunks = 69